import { render, staticRenderFns } from "./MainAuthLayout.vue?vue&type=template&id=4ad81bc8&"
import script from "./MainAuthLayout.vue?vue&type=script&lang=js&"
export * from "./MainAuthLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports